// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"610":"4021fd6e","963":"4021fd6e"}[chunkId] + ".chunk.css";
};